module.exports = __webpack_public_path__ + "img/odss_title_old.eb70c302.svg";